import { useMemo } from 'react';

import { getCurrentAvailabilities } from '../../../components/settings-page/schedule-calendar/Calendar.utils';
import { useMainSelector } from '../../useMainSelector';

export const useAvailabilities = () => {
  const {
    settings: {
      handover: { availabilities, selectedDate, filter, calendarView },
    },
  } = useMainSelector();

  const currentAvailabilities = useMemo(
    () =>
      selectedDate
        ? getCurrentAvailabilities(selectedDate, availabilities, filter)
        : [],
    [availabilities, filter, selectedDate],
  );

  return {
    availabilities,
    selectedDate,
    filter,
    currentAvailabilities,
    calendarView,
  };
};
